const styles = {
  primary: 'border border-cyan-300/60 bg-cyan-300 text-[#041014] shadow-[0_0_28px_rgba(103,232,249,.12)] hover:bg-cyan-200',
  secondary: 'border border-white/12 bg-white/[.045] text-slate-100 hover:border-cyan-300/25 hover:bg-white/[.075]',
  danger: 'border border-rose-400/30 bg-rose-400/10 text-rose-200 hover:bg-rose-400/18',
  ghost: 'border border-transparent text-slate-400 hover:border-white/10 hover:bg-white/[.035] hover:text-slate-100',
};
export function Button({ variant = 'primary', className = '', ...props }) {
  return <button className={`inline-flex h-10 items-center justify-center gap-2 px-4 text-sm font-semibold tracking-[-.01em] transition duration-150 active:translate-y-px disabled:pointer-events-none disabled:opacity-35 ${styles[variant]} ${className}`} {...props}/>;
}
